import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=24ddb8fc&"
import script from "./PrivacyConsent.vue?vue&type=script&lang=js&"
export * from "./PrivacyConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports